import { RestRequest, RestContext, ResponseFunction } from 'msw'
import {
  addToEntityListData,
  updateEntityListData,
  deleteEntityListData,
} from '../../modules/mockDataCommon'
import { requireAuthenticatedUser } from '../../decorators'
import { validationFailureBody } from '../../modules/validationFailure'
import { getTaskListData } from './mockData'
import type { ITask } from '~/types/task/models'

interface GetTasksResponse {
  data: ITask[]
}

async function getTasks(
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) {
  console.log(`'Returning tasks.`)
  const responseBody = { data: await getTaskListData() }
  return res(ctx.status(200), ctx.json(responseBody))
}

// interface GetTaskOverviewResponse {
//   data: ITaskOverview[]
// }

// async function getTaskOverview_byId(
//   req: RestRequest,
//   res: ResponseFunction,
//   ctx: RestContext
// ) {
//   const { id } = req.params
//   console.log(`'Returning overview for task "${id}".`)
//   const responseBody = { data: overviewData }
//   return res(ctx.status(200), ctx.json(responseBody))
// }

/**
 * The server's refusal of a `case` that is not a whole select item
 * (cynque-api-server #1739): a bare id is a 400, `Task.case.label: Field
 * required`. Null -- unlinking -- is accepted. Undefined when the body is fine.
 */
async function caseSelectItemRejection(
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) {
  const body = await req.json().catch(() => undefined)
  const caseValue = body?.case
  if (
    caseValue === undefined ||
    caseValue === null ||
    typeof caseValue?.label === 'string'
  ) {
    return undefined
  }
  return res(
    ctx.status(400),
    ctx.json(
      validationFailureBody({
        path: req.url.pathname,
        extra: [{ message: 'Field required', key: 'case.label' }],
      })
    )
  )
}

// post

const postTask = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return (
    (await caseSelectItemRejection(req, res, ctx)) ??
    addToEntityListData(req, res, ctx, getTaskListData)
  )
}

const patchTask = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return (
    (await caseSelectItemRejection(req, res, ctx)) ??
    updateEntityListData(req, res, ctx, getTaskListData)
  )
}

const deleteTask = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return deleteEntityListData(req, res, ctx, getTaskListData)
}

export const handlers = [
  {
    method: 'get',
    path: '/api/tasks',
    handler: getTasks,
  },
  // {
  //   method: 'get',
  //   path: '/api/tasks/:id/overview',
  //   handler: getTaskOverview_byId,
  // },
  {
    method: 'post',
    path: '/api/tasks',
    handler: postTask,
  },
  {
    method: 'patch',
    path: '/api/tasks/:id',
    handler: patchTask,
  },
  {
    method: 'delete',
    path: '/api/tasks/:id',
    handler: deleteTask,
  },
].map((h) => ({ ...h, ...{ handler: requireAuthenticatedUser(h.handler) } }))
